export enum LabelColorsEnum {
  Chilli = '0',
  Curry = '1',
  SingleSpices = '2',
  Herbs = '3',
  Mix = '4',
  Paprika = '5',
  Pepper = '6',
  Salt = '7',
}

export enum LabelColorsTranslations {
  Chilli = 'Chili (rot)',
  Curry = 'Curry (gelb)',
  SingleSpices = 'Einzelgewürze (grün-braun)',
  Herbs = 'Kräuter (grün)',
  Mix = 'Mischungen (orange)',
  Paprika = 'Paprika (rot)',
  Pepper = 'Pfeffer (grau)',
  Salt = 'Salz (blau)',
}
